<template>
  <div class="concat-us flex flex-end">
    <div class="concat-us-wrapper">
      <span class="hmicon icon-fuwuzhongxin"></span>
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "在线咨询"
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.concat-us-wrapper {
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 26px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;
  font-size: 12px;
  .hmicon {
    margin-right: 4px;
  }
}
</style>
